import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const TermsOfUse = () => {
    const navigate = useNavigate();

    return (
        <div className="min-h-screen bg-background text-foreground font-sans p-6 md:p-12">
            <div className="max-w-4xl mx-auto">
                <button
                    onClick={() => navigate(-1)}
                    className="flex items-center gap-2 text-muted-foreground hover:text-foreground mb-8 transition-colors"
                >
                    <ArrowLeft className="w-4 h-4" />
                    Voltar
                </button>

                <h1 className="text-3xl font-bold mb-8">Termos de Uso</h1>

                <div className="prose dark:prose-invert max-w-none space-y-6 text-muted-foreground">
                    <p>Última atualização: {new Date().toLocaleDateString('pt-BR')}</p>

                    <h2 className="text-xl font-semibold text-foreground mt-8 mb-4">1. Termos</h2>
                    <p>
                        Ao acessar ao site SkipLater, concorda em cumprir estes termos de serviço, todas as leis e regulamentos aplicáveis ​​e concorda que é responsável pelo cumprimento de todas as leis locais aplicáveis. Se você não concordar com algum desses termos, está proibido de usar ou acessar este site. Os materiais contidos neste site são protegidos pelas leis de direitos autorais e marcas comerciais aplicáveis.
                    </p>

                    <h2 className="text-xl font-semibold text-foreground mt-8 mb-4">2. Uso de Licença</h2>
                    <p>
                        É concedida permissão para baixar temporariamente uma cópia dos materiais (informações ou software) no site SkipLater , apenas para visualização transitória pessoal e não comercial. Esta é a concessão de uma licença, não uma transferência de título e, sob esta licença, você não pode:
                    </p>
                    <ul className="list-disc pl-6 space-y-2">
                        <li>modificar ou copiar os materiais; </li>
                        <li>usar os materiais para qualquer finalidade comercial ou para exibição pública (comercial ou não comercial); </li>
                        <li>tentar descompilar ou fazer engenharia reversa de qualquer software contido no site SkipLater; </li>
                        <li>remover quaisquer direitos autorais ou outras notações de propriedade dos materiais; ou </li>
                        <li>transferir os materiais para outra pessoa ou 'espelhe' os materiais em qualquer outro servidor.</li>
                    </ul>
                    <p>
                        Esta licença será automaticamente rescindida se você violar alguma dessas restrições e poderá ser rescindida por SkipLater a qualquer momento. Ao encerrar a visualização desses materiais ou após o término desta licença, você deve apagar todos os materiais baixados em sua posse, seja em formato eletrónico ou impresso.
                    </p>

                    <h2 className="text-xl font-semibold text-foreground mt-8 mb-4">3. Isenção de responsabilidade</h2>
                    <p>
                        Os materiais no site da SkipLater são fornecidos 'como estão'. SkipLater não oferece garantias, expressas ou implícitas, e, por este meio, isenta e nega todas as outras garantias, incluindo, sem limitação, garantias implícitas ou condições de comercialização, adequação a um fim específico ou não violação de propriedade intelectual ou outra violação de direitos.
                    </p>
                    <p>
                        Além disso, o SkipLater não garante ou faz qualquer representação relativa à precisão, aos resultados prováveis ​​ou à confiabilidade do uso dos materiais em seu site ou de outra forma relacionado a esses materiais ou em sites vinculados a este site.
                    </p>

                    <h2 className="text-xl font-semibold text-foreground mt-8 mb-4">4. Limitações</h2>
                    <p>
                        Em nenhum caso o SkipLater ou seus fornecedores serão responsáveis ​​por quaisquer danos (incluindo, sem limitação, danos por perda de dados ou lucro ou devido a interrupção dos negócios) decorrentes do uso ou da incapacidade de usar os materiais em SkipLater, mesmo que SkipLater ou um representante autorizado da SkipLater tenha sido notificado oralmente ou por escrito da possibilidade de tais danos. Como algumas jurisdições não permitem limitações em garantias implícitas, ou limitações de responsabilidade por danos conseqüentes ou incidentais, essas limitações podem não se aplicar a você.
                    </p>

                    <h2 className="text-xl font-semibold text-foreground mt-8 mb-4">5. Precisão dos materiais</h2>
                    <p>
                        Os materiais exibidos no site da SkipLater podem incluir erros técnicos, tipográficos ou fotográficos. SkipLater não garante que qualquer material em seu site seja preciso, completo ou atual. SkipLater pode fazer alterações nos materiais contidos em seu site a qualquer momento, sem aviso prévio. No entanto, SkipLater não se compromete a atualizar os materiais.
                    </p>

                    <h2 className="text-xl font-semibold text-foreground mt-8 mb-4">6. Links</h2>
                    <p>
                        O SkipLater não analisou todos os sites vinculados ao seu site e não é responsável pelo conteúdo de nenhum site vinculado. A inclusão de qualquer link não implica endosso por SkipLater do site. O uso de qualquer site vinculado é por conta e risco do usuário.
                    </p>

                    <h2 className="text-xl font-semibold text-foreground mt-8 mb-4">Modificações</h2>
                    <p>
                        O SkipLater pode revisar estes termos de serviço do site a qualquer momento, sem aviso prévio. Ao usar este site, você concorda em ficar vinculado à versão atual desses termos de serviço.
                    </p>

                    <h2 className="text-xl font-semibold text-foreground mt-8 mb-4">Lei aplicável</h2>
                    <p>
                        Estes termos e condições são regidos e interpretados de acordo com as leis do SkipLater e você se submete irrevogavelmente à jurisdição exclusiva dos tribunais naquele estado ou localidade.
                    </p>
                </div>
            </div>
        </div>
    );
};

export default TermsOfUse;
